import React from "react";
import { Text, Badge } from '@mantine/core';

import { utils } from "../../utils/globalVariables";
import { getObjectParam2, sqlDateToHumanDate, getPropInSubLevelRole, safeValue, numberFormatter, stringDivider } from "../../utils/globalFunctions";

import LabelContentInline from "../../components/general/LabelContentInline";

const StokItemRusakData = ({ stateData }) => {
  return (
    <React.Fragment>
      <LabelContentInline
        stateColLabel={4}
        stateLabel='Kategori'
        stateContent={stateData.stock_category_name}
        stateDivider={true}
      />

      <LabelContentInline
        stateColLabel={4}
        stateLabel='Sub Kategori'
        stateContent={stateData.stock_category_sub_name}
        stateDivider={true}
      />

      <LabelContentInline
        stateColLabel={4}
        stateLabel='Supplier'
        stateContent={stateData.supplier_name}
        stateDivider={true}
      />

      <LabelContentInline
        stateColLabel={4}
        stateLabel='Tanggal Pembelian'
        stateContent={sqlDateToHumanDate({
          stateDate: stateData.stock_tanggal_beli,
          stateWithTime: false,
          stateLang: 'id',
          stateIsShort: false,
          stateDay: false,
          stateDefaultValue: ' - ',
          stateDateType: 'day'
        })}
        stateDivider={true}
      />

      <LabelContentInline
        stateColLabel={4}
        stateLabel='Harga Pembelian'
        stateContent={'Rp ' + numberFormatter({ stateValue: stateData.stock_harga_beli })}
        stateDivider={true}
      />

      <LabelContentInline
        stateColLabel={4}
        stateLabel='Harga Penjualan'
        stateContent={'Rp ' + numberFormatter({ stateValue: stateData.stock_harga_jual })}
        stateDivider={true}
      />

      <LabelContentInline
        stateColLabel={4}
        stateLabel='Masa Garansi'
        stateContent={
          <Text>
            <Text>
              {safeValue(stateData.stock_masa_garansi_bulan, '0') + ' Bulan'}
            </Text>
            <Text>
              {safeValue(stateData.stock_masa_garansi_hari, '0') + ' Hari'}
            </Text>
          </Text>
        }
        stateDivider={true}
      />

      <LabelContentInline
        stateColLabel={4}
        stateLabel='Serial Number'
        stateContent={stateData.stock_serial_number ? stateData.stock_serial_number : ' - '}
        stateDivider={true}
      />

      <LabelContentInline
        stateColLabel={4}
        stateLabel='Jumlah Stok'
        stateContent={numberFormatter({ stateValue: stateData.stock_jumlah })}
        stateDivider={true}
      />

      <LabelContentInline
        stateColLabel={4}
        stateLabel='Kerusakan'
        stateContent={stateData.stock_rusak_info}
        stateDivider={true}
      />

      <LabelContentInline
        stateColLabel={4}
        stateLabel='Tanda'
        stateContent={
          <React.Fragment>
            <Badge
              size='md'
              color={getObjectParam2(utils.stockItemStatus, stateData.stock_status, 'color', 'gray')}
            >
              {getObjectParam2(utils.stockItemStatus, stateData.stock_status, 'caption', ' - ')}
            </Badge>

            {stateData.customer_name &&
              // (stateData.stock_status === utils.stockItemStatus.tagged.value) &&
              <Text size='sm' color={getObjectParam2(utils.stockItemStatus, stateData.stock_status, 'color', 'gray')} mt='sm'>
                Item ditandai untuk customer {safeValue(stateData.customer_name, ' - ')}
              </Text>
            }

            {stateData.tagged_project_id &&
              // (stateData.stock_status === utils.stockItemStatus.tagged.value) &&
              <Text size='sm' color={getObjectParam2(utils.stockItemStatus, stateData.stock_status, 'color', 'gray')} mt='sm'>
                Item ditandai untuk project {stringDivider(stateData.tagged_project_id, [4, 6, 8], '.', ' - ')}
              </Text>
            }
          </React.Fragment>
        }
        stateDivider={true}
      />

      <LabelContentInline
        stateColLabel={4}
        stateLabel='Status'
        stateContent={stateData.stock_is_active === '1' ? 'Aktif' : 'Non Aktif'}
        stateDivider={true}
      />

      <LabelContentInline
        stateColLabel={4}
        stateLabel='Tanggal Input'
        stateContent={sqlDateToHumanDate({
          stateDate: stateData.stock_created_datetime,
          stateWithTime: true,
          stateLang: 'id',
          stateIsShort: false,
          stateDay: false,
          stateDefaultValue: ' - ',
          stateDateType: 'day'
        })}
        stateDivider={true}
      />

      <LabelContentInline
        stateColLabel={4}
        stateLabel='Diinput Oleh'
        stateContent={safeValue(stateData.stock_created_user_name, '-')}
        stateDivider={true}
      />

      <LabelContentInline
        stateColLabel={4}
        stateLabel='Jabatan'
        stateContent={getPropInSubLevelRole(stateData.stock_created_user_sub_level, 'caption', '-')}
        stateDivider={false}
      />
    </React.Fragment>
  )
}

export default StokItemRusakData;